/* Libs */
import React from 'react';
import ReactDOM from 'react-dom';

/* Containers */
import App from '~/src/containers/App';

/* Utilities */
// eslint-disable-next-line import/no-extraneous-dependencies
import 'mobx-react-lite/batchingForReactDom';
import { initDatadogRum } from '~/src/utils/datadogRum';

/* Styles */
import './index.css';
import 'tailwindcss/tailwind.css';

initDatadogRum();

ReactDOM.render(<App />, document.getElementById('root'));
